/* X Nutrition Labs — filtro por línea, pestañas de la guía, video y compra.
   Vanilla, sin dependencias. Cada parte se activa sólo si su DOM existe, así
   el mismo archivo sirve para la colección y para la ficha. */
(function () {
  'use strict';

  if (window.__xnLabsReady) return; // las secciones lo cargan varias veces
  window.__xnLabsReady = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var LINEAS = ['essential', 'vitality', 'beauty'];

  /* ------------------------------------------------------------------
     Filtro de la grilla

     Los disparadores son cualquier `[data-xn-labs-filter]` de la página: hoy
     son los 4 botones de la barra de líneas, que vive dentro de la propia
     sección de la grilla. El estado vive en el hash (#essential), que es lo
     que permite que la ficha mande de vuelta a la colección ya filtrada y que
     el botón "atrás" del navegador funcione.
     ------------------------------------------------------------------ */
  function grilla() {
    return document.querySelector('[data-xn-labs-grid]');
  }

  function lineaDelHash() {
    var h = (window.location.hash || '').replace('#', '').toLowerCase();
    return LINEAS.indexOf(h) !== -1 ? h : 'all';
  }

  function aplicarFiltro(linea, animar) {
    var g = grilla();
    if (!g) return;

    var pills = g.querySelectorAll('[data-xn-labs-filter]');
    var nombre = '';
    pills.forEach(function (p) {
      var activa = p.getAttribute('data-xn-labs-filter') === linea;
      p.setAttribute('aria-pressed', activa ? 'true' : 'false');
      if (activa && linea !== 'all') nombre = p.getAttribute('data-name') || linea;
    });

    var visibles = 0;
    g.querySelectorAll('.xn-labs-card').forEach(function (card) {
      var mostrar = linea === 'all' || card.getAttribute('data-line') === linea;
      card.hidden = !mostrar;
      card.classList.remove('is-entering');
      if (mostrar) {
        if (animar && !reduce.matches) {
          card.style.setProperty('--xn-labs-i', visibles);
          void card.offsetWidth; // reinicia la animación
          card.classList.add('is-entering');
        }
        visibles++;
      }
    });

    var titulo = g.querySelector('[data-xn-labs-title]');
    if (titulo) {
      if (linea === 'all') {
        titulo.textContent = g.getAttribute('data-label-all') || '';
      } else {
        titulo.textContent = (g.getAttribute('data-label-line') || '') + ' ';
        var strong = document.createElement('strong');
        strong.textContent = nombre;
        titulo.appendChild(strong);
      }
    }

    // El color del ícono del título acompaña a la línea elegida.
    LINEAS.forEach(function (l) {
      g.classList.toggle('xn-labs--' + l, l === linea);
    });

    var status = g.querySelector('[data-xn-labs-status]');
    if (status) {
      status.textContent =
        visibles + (visibles === 1 ? ' producto' : ' productos') + (nombre ? ' de ' + nombre : '');
    }
  }

  function initFiltro() {
    if (!grilla()) return;

    aplicarFiltro(lineaDelHash(), false);

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-xn-labs-filter]');
      if (!btn) return;
      event.preventDefault();

      var linea = btn.getAttribute('data-xn-labs-filter');
      var url = window.location.pathname + window.location.search + (linea === 'all' ? '' : '#' + linea);
      window.history.replaceState(null, '', url);
      aplicarFiltro(linea, true);

      // Un disparador fuera de la sección de la grilla (por ejemplo un link en
      // otra parte de la página) tiene que bajar hasta ella; los botones de la
      // barra ya están ahí y moverían la página sin motivo.
      if (!grilla().contains(btn)) {
        grilla().scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      }
    });

    window.addEventListener('hashchange', function () {
      aplicarFiltro(lineaDelHash(), true);
    });

    // Llegando con #beauty desde la ficha, el navegador no salta a la grilla
    // porque no hay un elemento con ese id: se lo lleva a mano.
    if (lineaDelHash() !== 'all') {
      window.requestAnimationFrame(function () {
        grilla().scrollIntoView({ block: 'start' });
      });
    }
  }

  /* ------------------------------------------------------------------
     Pestañas de la guía (patrón ARIA tabs, activación automática)
     ------------------------------------------------------------------ */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-xn-labs-tabs]').forEach(function (box) {
      if (box.dataset.xnLabsTabsReady === 'true') return;
      box.dataset.xnLabsTabsReady = 'true';

      var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      var atajos = Array.prototype.slice.call(box.querySelectorAll('[data-xn-labs-tab-jump]'));
      if (!tabs.length) return;

      function seleccionar(tab, foco) {
        tabs.forEach(function (t) {
          var sel = t === tab;
          t.setAttribute('aria-selected', sel ? 'true' : 'false');
          t.tabIndex = sel ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !sel;
          panel.classList.remove('is-entering');
          if (sel && !reduce.matches) {
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        });
        // La lista lateral es un espejo de la barra: se marca la misma.
        atajos.forEach(function (a) {
          a.classList.toggle('is-active', a.getAttribute('data-xn-labs-tab-jump') === tab.getAttribute('aria-controls'));
        });
        if (foco) tab.focus();
        // En mobile la barra es un scroller: que la pestaña elegida quede a la
        // vista. Se mueve sólo la barra en horizontal; scrollIntoView movería
        // también la página hacia arriba cuando se elige desde la lista lateral.
        var bar = tab.parentElement;
        if (bar.scrollWidth > bar.clientWidth) {
          var dx = tab.getBoundingClientRect().left - bar.getBoundingClientRect().left - 16;
          bar.scrollBy({ left: dx, behavior: reduce.matches ? 'auto' : 'smooth' });
        }
      }

      // Estado inicial: sólo con JS se ocultan los paneles no activos.
      tabs.forEach(function (t, i) {
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = i !== 0;
      });

      box.addEventListener('click', function (e) {
        var tab = e.target.closest('[role="tab"]');
        if (tab && tabs.indexOf(tab) !== -1) {
          seleccionar(tab, false);
          return;
        }
        var atajo = e.target.closest('[data-xn-labs-tab-jump]');
        if (!atajo) return;
        var destino = tabs.filter(function (t) {
          return t.getAttribute('aria-controls') === atajo.getAttribute('data-xn-labs-tab-jump');
        })[0];
        if (destino) seleccionar(destino, false);
      });

      box.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i === -1) return;
        var n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) {
          e.preventDefault();
          seleccionar(tabs[n], true);
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     Video en <dialog>. El iframe se crea al abrir y se destruye al cerrar.
     ------------------------------------------------------------------ */
  function initVideo() {
    document.addEventListener('click', function (e) {
      var abrir = e.target.closest('[data-xn-labs-video-open]');
      if (abrir) {
        var seccion = abrir.closest('.xn-labs-video');
        var dialog = seccion && seccion.querySelector('[data-xn-labs-video]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        var frame = dialog.querySelector('[data-xn-labs-video-frame]');
        frame.innerHTML = '';
        var iframe = document.createElement('iframe');
        iframe.src = dialog.getAttribute('data-src');
        iframe.title = dialog.getAttribute('aria-label') || 'Video';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        frame.appendChild(iframe);
        dialog.showModal();
        return;
      }

      var cerrar = e.target.closest('[data-xn-labs-video-close]');
      var dlg = cerrar ? cerrar.closest('dialog') : null;
      // Clic sobre el backdrop: el target es el propio <dialog>.
      if (!dlg && e.target.matches && e.target.matches('[data-xn-labs-video]')) dlg = e.target;
      if (dlg) dlg.close();
    });

    document.addEventListener(
      'close',
      function (e) {
        if (!e.target.matches || !e.target.matches('[data-xn-labs-video]')) return;
        var frame = e.target.querySelector('[data-xn-labs-video-frame]');
        if (frame) frame.innerHTML = '';
      },
      true
    );
  }

  /* ------------------------------------------------------------------
     Compra: variante, cantidad y agregar al carrito por AJAX.
     Sin JS el <form> hace el POST normal a /cart/add y lleva al carrito.
     ------------------------------------------------------------------ */
  function actualizarContadorHeader(cantidad) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = cantidad;
    });
    var wrapper = document.querySelector('.header-cart');
    if (wrapper && !wrapper.querySelector('.cart-count') && cantidad > 0) {
      var span = document.createElement('span');
      span.className = 'cart-count';
      span.textContent = cantidad;
      wrapper.appendChild(span);
    }
    document.querySelectorAll('.btn_cart_count').forEach(function (el) {
      el.textContent = '( ' + cantidad + ' )';
    });
  }

  function initCompra(root) {
    (root || document).querySelectorAll('[data-xn-labs-buy]').forEach(function (box) {
      if (box.dataset.xnLabsBuyReady === 'true') return;
      box.dataset.xnLabsBuyReady = 'true';

      var form = box.querySelector('form');
      if (!form) return;
      var qty = form.querySelector('input[name="quantity"]');
      var submit = form.querySelector('[data-xn-labs-submit]');
      var status = form.querySelector('[data-xn-labs-status]');
      var select = form.querySelector('[data-xn-labs-variant]');
      var precio = box.querySelector('[data-xn-labs-price]');

      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-xn-labs-qty]');
        if (!b || !qty) return;
        var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-xn-labs-qty'), 10);
        qty.value = Math.max(1, v);
      });

      if (select && precio) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          precio.innerHTML = '';
          if (opt.getAttribute('data-compare')) {
            var s = document.createElement('s');
            s.className = 'xn-labs-buy__compare';
            s.textContent = opt.getAttribute('data-compare');
            precio.appendChild(s);
          }
          var amount = document.createElement('span');
          amount.className = 'xn-labs-buy__amount';
          amount.textContent = opt.getAttribute('data-price');
          precio.appendChild(amount);
          var disponible = opt.getAttribute('data-available') === 'true';
          submit.disabled = !disponible;
          submit.textContent = submit.getAttribute(disponible ? 'data-label-add' : 'data-label-soldout');
        });
      }

      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var original = submit.textContent;
        submit.disabled = true;
        submit.textContent = 'Agregando…';
        status.className = 'xn-labs-buy__status';
        status.textContent = '';

        var datos = new FormData(form);
        var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: datos,
        })
          .then(function (r) {
            return r.json().then(function (j) {
              if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar');
              return j;
            });
          })
          .then(function () {
            return fetch(raiz + 'cart.js').then(function (r) {
              return r.json();
            });
          })
          .then(function (cart) {
            actualizarContadorHeader(cart.item_count);
            status.innerHTML = '';
            status.appendChild(document.createTextNode('Listo, se agregó al carrito. '));
            var a = document.createElement('a');
            a.href = raiz + 'cart';
            a.textContent = 'Ver carrito';
            status.appendChild(a);
          })
          .catch(function (err) {
            status.classList.add('is-error');
            status.textContent = err.message;
          })
          .then(function () {
            submit.disabled = false;
            submit.textContent = original;
          });
      });
    });
  }

  function initAll(root) {
    initTabs(root);
    initCompra(root);
  }

  function arrancar() {
    initFiltro();
    initVideo();
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    if (e.target.querySelector('[data-xn-labs-grid]')) aplicarFiltro(lineaDelHash(), false);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.matches && e.target.matches('[role="tab"]') ? e.target : null;
    if (tab) tab.click();
  });
})();
